"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BasePostLoginFlowStrategy = function BasePostLoginFlowStrategy(auth, appInfo, pushState, log) {
  (0, _classCallCheck3.default)(this, BasePostLoginFlowStrategy);

  this.auth = auth;
  this.appInfo = appInfo;
  this.pushState = pushState;
  this.log = log;
};

exports.default = BasePostLoginFlowStrategy;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/login/strategy/BasePostLoginFlowStrategy.js
// module id = 417
// module chunks = 0